(function () {
  var loader = document.querySelector('script[data-al-locale-navigation]');
  var localeRoot = loader && loader.dataset ? (loader.dataset.localeRoot || '') : '';
  localeRoot = String(localeRoot).trim().replace(/\/+$/, '');

  // The primary locale uses '/'. After trimming, that becomes an empty
  // string and needs no URL prefixing. Non-primary locales use roots such
  // as /en, /es, /fr, /de or /nl, supplied by Shopify via routes.root_url.
  if (!localeRoot) return;

  function localizeLink(link) {
    if (!link || !link.getAttribute) return;

    var rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.charAt(0) === '#') return;
    if (/^(?:mailto:|tel:|sms:|javascript:|data:)/i.test(rawHref)) return;
    if (rawHref.slice(0, 2) === '//') return;

    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    var pathname = url.pathname || '/';
    if (pathname === localeRoot || pathname.indexOf(localeRoot + '/') === 0) return;

    url.pathname = localeRoot + (pathname.charAt(0) === '/' ? pathname : '/' + pathname);

    // Keep relative storefront links relative, while preserving query strings
    // and hashes (variant IDs, search terms, theme preview parameters, etc.).
    if (/^https?:/i.test(rawHref)) {
      link.setAttribute('href', url.href);
    } else {
      link.setAttribute('href', url.pathname + url.search + url.hash);
    }
  }

  function localizeTree(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches('a[href]')) {
      localizeLink(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('a[href]').forEach(localizeLink);
    }
  }

  function init() {
    localizeTree(document);

    // Theme sections and product grids can be replaced dynamically. Keep
    // newly inserted customer-facing links in the active Shopify locale too.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(localizeTree);
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
